export enum TaskType {
  START_ODOMETER_READING,
  INCIDENT ,
  WORK_ORDER,
}
